import { checkIsEmerson } from "@shared/hooks/useCheckIsEmerson/checkIsEmerson";
import ReactRailsUJS from "@shared/polyfill/react_ujs";
import { clientInitCoralogix } from "@shared/utils/clientInitCoralogix/clientInitCoralogix.client";
import { clientInitDatadogRum } from "@shared/utils/clientInitDatadogRum/clientInitDatadogRum.client";
import { hello } from "@shared/utils/hello";
import { initFsAnalytics } from "@shared/utils/initFsAnalytics/initFsAnalytics";
import { initSentry } from "@shared/utils/initSentry/initSentry";

initFsAnalytics(checkIsEmerson() ? "emerson.unauth" : "unauth");

const componentRequireContext = require.context("@unauthenticated/signupSignin", false);

initSentry({
  enableRouterInstrumentation: true,
  tracesSampleRate: 0.01,
});
clientInitCoralogix({
  sessionConfig: {
    sessionSampleRate: 0,
    alwaysTrackSessionsWithErrors: false,
  },
});
clientInitDatadogRum();

ReactRailsUJS.useContext(componentRequireContext);
hello();
